import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaAward,
  FaUsers,
  FaChalkboardTeacher,
  FaLaptopCode,
  FaHandshake,
  FaRocket,
  FaCheckCircle,
  FaHeart,
  FaArrowRight,
  FaCuttlefish,
  FaCode,
  FaMobileAlt,
  FaJava,
  FaPython,
  FaDatabase,
  FaMicrosoft,
  FaStar,
} from "react-icons/fa";
import { SiCplusplus } from "react-icons/si";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/about.css";

const About = () => {
  const navigate = useNavigate();

  const stats = [
    { number: "21+", label: "Years of Excellence", icon: FaAward },
    { number: "8760+", label: "Students Trained", icon: FaUsers },
    { number: "21+", label: "Expert Trainers", icon: FaChalkboardTeacher },
    { number: "100+", label: "Courses Offered", icon: FaLaptopCode },
  ];

  const expertise = [
    { name: "C & C++ Programming", icon: FaCuttlefish },
    { name: "Data Structures & Algorithms", icon: FaCode },
    { name: "Full Stack Web Development", icon: FaLaptopCode },
    { name: "Android App Development", icon: FaMobileAlt },
    { name: "Java Core & Advanced", icon: FaJava },
    { name: "Python Programming", icon: FaPython },
    { name: "Dot Net Framework", icon: FaMicrosoft },
    { name: "Database Management", icon: FaDatabase },
  ];

  const features = [
    {
      icon: FaRocket,
      title: "Industry-Ready Curriculum",
      description:
        "Our courses are designed with input from industry experts to ensure you learn what employers actually need.",
    },
    {
      icon: FaHandshake,
      title: "100% Placement Assistance",
      description:
        "We provide comprehensive placement support including mock interviews, resume building, and direct company connections.",
    },
    {
      icon: FaHeart,
      title: "Lifelong Support",
      description:
        "Even after course completion, you get lifetime access to materials and continued guidance from our mentors.",
    },
  ];

  const timeline = [
    {
      year: "2005",
      title: "The Beginning",
      description:
        "Sensible Academy was founded with a vision to provide quality IT education in Chhattisgarh.",
    },
    {
      year: "2010",
      title: "Expansion",
      description:
        "Expanded our course offerings to include web development and mobile app development.",
    },
    {
      year: "2015",
      title: "Placement Excellence",
      description:
        "Achieved 95% placement rate with students placed in top MNCs across India.",
    },
    {
      year: "2024",
      title: "Today",
      description:
        "Recognized as the best software training institute in Chhattisgarh with 8760+ successful alumni.",
    },
  ];

  return (
    <div className="about-page-wrapper">
      <PublicNavbar />

      {/* Hero Section */}
      <div className="about-page-hero">
        <Container>
          <Row className="align-items-center min-vh-50 py-5 About-hesdersd">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="about-page-hero-title display-4 fw-bold text-white mb-4">
                About <span className="text-warning">Sensible Academy</span>
              </h1>
              <p className="about-page-hero-subtitle lead text-white mb-4">
                Empowering careers through quality education since 2005
              </p>
              <div className="about-page-hero-stats d-flex justify-content-center gap-4">
                <div className="text-center">
                  <h3 className="text-white fw-bold">21+</h3>
                  <p className="text-white-50">Years</p>
                </div>
                <div className="text-center">
                  <h3 className="text-white fw-bold">8760+</h3>
                  <p className="text-white-50">Students</p>
                </div>
                <div className="text-center">
                  <h3 className="text-white fw-bold">100+</h3>
                  <p className="text-white-50">Courses</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="about-page-hero-wave">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 200"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </div>

      {/* Stats Cards */}
      <Container className="about-page-container py-5">
        <Row className="g-4">
          {stats.map((stat, idx) => (
            <Col md={3} sm={6} key={idx}>
              <Card className="about-page-stat-card h-100 border-0 shadow-sm">
                <Card.Body className="text-center">
                  <div className="about-page-stat-icon-wrapper mb-3">
                    <stat.icon className="about-page-stat-icon" size={40} />
                  </div>
                  <h2 className="fw-bold text-primary mb-2">{stat.number}</h2>
                  <p className="text-muted mb-0">{stat.label}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Mission & Vision */}
      <Container className="about-page-container py-5">
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="about-page-mission-content p-4">
              <h2 className="display-5 fw-bold mb-4">
                <span className="text-primary">Find Out More</span>
                <br />
                About Us
              </h2>
              <p className="lead mb-4">
                Sensible Academy, incorporated in 2005, started with the main
                objective of providing the most trustworthy software development
                services, web services as well as training & other services.
              </p>
              <p className="text-muted">
                <FaCheckCircle className="text-primary me-2" />
                Summer Vocational Training at Bhilai Durg Sensible Academy:
                Enhancing Skills for Future Careers
              </p>
              <div className="about-page-mission-badges mt-4">
                <span className="badge bg-primary me-2 mb-2">
                  Trusted since 2005
                </span>
                <span className="badge bg-primary me-2 mb-2">
                  ISO Certified
                </span>
                <span className="badge bg-primary me-2 mb-2">
                  Govt. Registered
                </span>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-page-vision-box p-4 bg-light rounded-4">
              <h3 className="fw-bold text-primary mb-4">Our Vision</h3>
              <p className="mb-4">
                To be the most trusted and innovative education provider,
                transforming passionate learners into skilled professionals
                ready to lead in the technology-driven world.
              </p>
              <h3 className="fw-bold text-primary mb-4 mt-5">Our Mission</h3>
              <p>
                To democratize education by providing affordable, high-quality
                training that bridges the gap between academic learning and
                industry requirements.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* What We're Expert In */}
      <div className="about-page-expert-section py-5">
        <Container>
          <h2 className="text-center display-5 fw-bold mb-5">
            <span className="text-primary">What We Are</span> Expert In
          </h2>
          <Row>
            {expertise.map((item, idx) => (
              <Col md={3} sm={6} className="mb-4" key={idx}>
                <Card className="about-page-expert-card h-100 border-0 shadow-sm">
                  <Card.Body className="text-center">
                    <div className="about-page-expert-icon mb-3">
                      <item.icon className="text-primary" size={28} />
                    </div>
                    <h6 className="fw-bold mb-0">{item.name}</h6>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Features */}
      <Container className="about-page-container py-5">
        <h2 className="text-center display-5 fw-bold mb-5">
          <span className="text-primary">Why Choose</span> Sensible Academy
        </h2>
        <Row>
          {features.map((feature, idx) => (
            <Col md={4} className="mb-4" key={idx}>
              <Card className="about-page-feature-card h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div className="about-page-feature-icon-wrapper mb-4">
                    <feature.icon
                      className="about-page-feature-icon"
                      size={40}
                    />
                  </div>
                  <h4 className="fw-bold mb-3">{feature.title}</h4>
                  <p className="text-muted">{feature.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Timeline Journey */}
      <div className="about-page-timeline-section py-5">
        <Container>
          <h2 className="text-center display-5 fw-bold mb-5 text-white">
            Our Journey
          </h2>
          <Row className="position-relative">
            {timeline.map((item, idx) => (
              <Col md={3} sm={6} className="mb-4" key={idx}>
                <Card className="about-page-timeline-card h-100 border-0">
                  <Card.Body className="text-center">
                    <div className="about-page-timeline-year mb-3">
                      {item.year}
                    </div>
                    <h5 className="fw-bold mb-3">{item.title}</h5>
                    <p className="text-muted small">{item.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Placement Process */}
      <Container className="about-page-container py-5">
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            <h2 className="display-5 fw-bold mb-4">
              <span className="text-primary">Placement</span> Process
            </h2>
            <p className="lead mb-4">
              Our institute's placement process is a meticulously structured
              roadmap designed to propel you towards your dream job.
            </p>
            <div className="about-page-placement-steps">
              <div className="about-page-step d-flex mb-4">
                <div className="about-page-step-number me-3">1</div>
                <div>
                  <h5 className="fw-bold">Skill Enhancement</h5>
                  <p className="text-muted">
                    Intensive training on technical and soft skills
                  </p>
                </div>
              </div>
              <div className="about-page-step d-flex mb-4">
                <div className="about-page-step-number me-3">2</div>
                <div>
                  <h5 className="fw-bold">Mock Interviews</h5>
                  <p className="text-muted">
                    Practice sessions with industry experts
                  </p>
                </div>
              </div>
              <div className="about-page-step d-flex mb-4">
                <div className="about-page-step-number me-3">3</div>
                <div>
                  <h5 className="fw-bold">Resume Building</h5>
                  <p className="text-muted">
                    Craft compelling resumes that stand out
                  </p>
                </div>
              </div>
              <div className="about-page-step d-flex mb-4">
                <div className="about-page-step-number me-3">4</div>
                <div>
                  <h5 className="fw-bold">Company Connect</h5>
                  <p className="text-muted">
                    Direct interaction with hiring partners
                  </p>
                </div>
              </div>
            </div>
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate("/contact")}
              className="about-page-cta-journey-btn mt-3"
            >
              Start Your Journey <FaArrowRight className="ms-2" />
            </Button>
          </Col>
          <Col lg={6}>
            <div className="about-page-placement-stats bg-light p-5 rounded-4">
              <h3 className="fw-bold text-primary mb-4">Our Achievements</h3>
              <div className="about-page-stat-item mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span>Placement Rate</span>
                  <span className="fw-bold">95%</span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "95%" }}
                  ></div>
                </div>
              </div>
              <div className="about-page-stat-item mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span>Top MNC Placements</span>
                  <span className="fw-bold">200+</span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "85%" }}
                  ></div>
                </div>
              </div>
              <div className="about-page-stat-item mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span>Average Package</span>
                  <span className="fw-bold">₹5.2 LPA</span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "75%" }}
                  ></div>
                </div>
              </div>
              <p className="text-muted mt-4">
                From skill enhancement to personalized career guidance, discover
                the strategic steps we take to ensure your successful transition
                from training to employment.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* CTA Section */}
      <div className="about-page-cta-section py-5">
        <Container className="text-center">
          <h2 className="display-5 fw-bold text-white mb-4">
            Ready to Start Your Journey?
          </h2>
          <p className="lead text-white mb-4">
            Join 8760+ successful students who transformed their careers with us
          </p>
          <Button
            variant="light"
            size="lg"
            className="about-page-cta-btn me-3"
            onClick={() => navigate("/register")}
          >
            Enroll Now
          </Button>
          <Button
            variant="outline-light"
            size="lg"
            className="about-page-cta-outline-btn"
            onClick={() => navigate("/contact")}
          >
            Contact Us
          </Button>
        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default About;
